import { DocumentContent, AsyncOpStatus } from 'phoenix/domain';

export interface DocumentRevision extends DocumentContent {
    AsyncPurgeOpStatus:AsyncOpStatus;
    AsyncTrashOpStatus:AsyncOpStatus;
    CreatedBy:string;
    DateCreated:string;
    Icon:string;
    VersionNumber:number;
    Links: {
        SelfUri:string;
        ContentUri:string;
        ContentUri_v2:string;
        PromoteUri:string;
    }
}

export const isDocumentRevision = (rev): rev is DocumentRevision => {
    return rev && angular.isDefined(rev.VersionNumber) && angular.isDefined(rev.Hash);
};


// WEBPACK FOOTER //
// ./src/phoenix/domain/document-revision.ts